import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function FadeUp({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClass = "", delay = 0, as: Tag = "h1", stagger = 0.12 }) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => {
        const text = typeof line === "string" ? line : line.text;
        const extra = typeof line === "string" ? "" : line.lineClass || "";
        return (
          <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
            <motion.span
              className={`block will-change-transform ${lineClass} ${extra}`}
              initial={{ y: "115%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 1, delay: delay + i * stagger, ease: EASE }}
            >
              {text}
            </motion.span>
          </span>
        );
      })}
    </Tag>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-neon ${className}`}>
      <span className="h-2 w-2 bg-neon" />
      {children}
    </span>
  );
}

export function SectionHead({ kicker, title, body, className = "" }) {
  return (
    <div className={className}>
      <FadeUp>
        <Eyebrow>{kicker}</Eyebrow>
      </FadeUp>
      <FadeUp delay={0.08}>
        <h2 className="mt-6 max-w-4xl font-display text-3xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[1.02] tracking-tight text-white">
          {title}
        </h2>
      </FadeUp>
      {body && (
        <FadeUp delay={0.14}>
          <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-fog">{body}</p>
        </FadeUp>
      )}
    </div>
  );
}
